import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.load()
  }

  load() {
    if (!this.hasUrlValue) return;

    console.log('Loading ', this.urlValue)

    fetch(this.urlValue, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(response => response.text())
    .then(js => {
      const script = document.createElement('script')
      script.textContent = js
      document.head.appendChild(script)
    })
  }
}
